import type { NativeRouteMeta } from '@retailer-platform/dashboard/routing-native'
import type { routes } from './routes'

export const nativeRouteMeta = {
  name: 'shiftsPartnerScoped',
  autoEnable: true,
} as const satisfies NativeRouteMeta<keyof typeof routes>
